<template>
  <ion-page>
    <master-layout pageTitle="لیست خودروهای مشتری">
      <ion-card>
        <ion-card-content>
          <div class="top_items">
            <div class="h5">خودروهای :
              <span v-if="customer"> {{customer.fullname}}</span>
            </div>
            <div>
            <router-link  :to="'/CustomerCar/Add/'+id">
              <ion-button >افزودن خودرو</ion-button>
            </router-link>
            </div>
          </div>

          <DataTable auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";

export default {
  data()
  {
    return {
      id:null,
      route : null,
      customer : null,
      headers:[
        'عنوان خودرو',
        'تیپ خودرو',
        'سال ساخت',
        'کیلومتر فعلی',
        'آخرین مراجعه',
        'امکانات'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
    this.route = 'car/ListAjax?customer_id='+this.id;
    const customer = await this.getCustomer({id : this.id});
    if (customer.ok)
      this.customer = customer.customer;
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  },
  methods:{
    ...mapActions("customer", {
      getCustomer: 'getCustomer'
    }),

  },
  watch: {
    // '$route.path': {
    //   handler(newUrl)
    //   {
    //     if (newUrl.indexOf('CustomerCar/list') >= 0)
    //     {
    //       this.id = this.$route.params.id;
    //       this.route = 'car/ListAjax?customer_id='+this.id+'&t=' + (new Date().getTime())
    //     }
    //   }
    // }
  }
};
</script>

<style scoped>
.top_items
{
  display: flex;
  justify-content: space-between;
}
.h5 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
</style>